<template>
  <section>
    <div class="container">
      <BaseBreadcrumb
        v-if="getBreadcrumb"
        :breadcrumb="getBreadcrumb"
        class="mb-8"
      />
      <BaseCard v-if="checkContent" class="seo-content-card">
        <div class="seo-content-card__heading" v-html="getSeoContent.heading" />
        <div class="seo-content-card__body" v-html="getSeoContent.body" />
      </BaseCard>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseBreadcrumb from '@design-system/base/breadcrumb/breadcrumb'
export default {
  name: 'SectionSeoContentBox',
  components: {
    BaseBreadcrumb
  },
  props: {
    className: {
      type: [String, Array],
      default: ''
    }
  },
  computed: {
    ...mapGetters('global', ['getSeoContent', 'getBreadcrumb']),
    checkContent () {
      return this.getSeoContent && this.getSeoContent?.body.trim().length !== 0
    }
  }
}
</script>

<style lang="scss">
.seo-content-card {
  &__heading {
    @apply bg-bg-cart p-4  rounded-lg;
    * {
      @apply text-title text__headline-5-md--semibold;
    }
  }
  &__body {
    @apply mt-4 text__body-3-md--regular lg:text__body-1-md--regular text-body-2;
    > h1,h2,h3,h4,h5,h6 {
    @apply mt-4;
    }
    h1 {
      @apply text__body-1-md--semibold  mb-2;
    }
    h2 {
      @apply text__headline-5-xs--semibold lg:text__body-1-md--semibold mb-2;
    }
    h3 {
      @apply text__headline-5-xs--bold lg:text__headline-5-md--bold mb-1;
    }
    h4 {
      @apply text__headline-5-xs--bold lg:text__headline-5-md--bold mb-1;
    }
    h5 {
      @apply text__headline-5-xs--bold lg:text__headline-5-md--bold mb-1;
    }
    ul {
      @apply list-disc pl-4;
    }
    p {
      @apply text__body-2-xs--regular lg:text__body-1-md--regular text-body-2;
    }
    ol, ul, menu{
      list-style: auto;
      padding: revert;
    }
  }
}
</style>
